import IntegrationsWithSnippets from './IntegrationsWithSnippets'

export default IntegrationsWithSnippets
